<script setup>
import { ref, computed } from 'vue'

const roles = [
  'Разработчик Node.js (Nest.js)',
  'Разработчик React JavaScript',
  'Разработчик VUE JavaScript',
  'Разработчик iOS (Swift)',
  'Разработчик Android (Kotlin, Java)',
  'Разработчик Java',
  'Разработчик PHP (Yii2, Laravel)',
  'Разработчик .net (ASP.net)',
  'Разработчик Python',
  'Разработчик С#',
  'Разработчик GO',
  'Тестировщик/QA',
  'Тестировщик/AQA (JAVA)',
  'DevOps',
  'Бизнес-аналитик',
  'Системный аналитик',
  'Руководитель проектов/project manager',
  'Дизайнер (Figma)',
  'Технический писатель',
]

const currentIndex = ref(0)

const prices = {
  0: [
    { level: 'Premiddle', hour: '2 400 ₽', month: '396 000 ₽' },
    { level: 'Middle', hour: '2 800 ₽', month: '462 000 ₽' },
    { level: 'Senior', hour: '3 100 ₽', month: '511 500 ₽' }
  ],
  1: [
    { level: 'Premiddle', hour: '2 400 ₽', month: '396 000 ₽' },
    { level: 'Middle', hour: '2 800 ₽', month: '462 000 ₽' },
    { level: 'Senior', hour: '3 100 ₽', month: '511 500 ₽' }
  ],
  2: [
    { level: 'Premiddle', hour: '2 400 ₽', month: '396 000 ₽' },
    { level: 'Middle', hour: '2 800 ₽', month: '462 000 ₽' },
    { level: 'Senior', hour: '3 100 ₽', month: '511 500 ₽' }
  ],
  3: [
    { level: 'Premiddle', hour: '3 000 ₽', month: '495 000 ₽' },
    { level: 'Middle', hour: '3 400 ₽', month: '561 000 ₽' },
    { level: 'Senior', hour: '3 700 ₽', month: '610 500 ₽' }
  ],
  4: [
    { level: 'Premiddle', hour: '3 000 ₽', month: '495 000 ₽' },
    { level: 'Middle', hour: '3 400 ₽', month: '561 000 ₽' },
    { level: 'Senior', hour: '3 700 ₽', month: '610 500 ₽' }
  ],
  5: [
    { level: 'Premiddle', hour: '2 800 ₽', month: '462 000 ₽' },
    { level: 'Middle', hour: '3 200 ₽', month: '528 000 ₽' },
    { level: 'Senior', hour: '3 700 ₽', month: '610 500 ₽' }
  ],
  6: [
    { level: 'Premiddle', hour: '2 100 ₽', month: '346 500 ₽' },
    { level: 'Middle', hour: '2 300 ₽', month: '379 500 ₽' },
    { level: 'Senior', hour: '2 500 ₽', month: '412 500 ₽' }
  ],
  7: [
    { level: 'Premiddle', hour: '2 300 ₽', month: '379 500 ₽' },
    { level: 'Middle', hour: '2 600 ₽', month: '429 000 ₽' },
    { level: 'Senior', hour: '2 700 ₽', month: '445 500 ₽' }
  ],
  8: [
    { level: 'Premiddle', hour: '2 400 ₽', month: '396 000 ₽' },
    { level: 'Middle', hour: '2 800 ₽', month: '462 000 ₽' },
    { level: 'Senior', hour: '3 100 ₽', month: '511 500 ₽' }
  ],
  9: [
    { level: 'Premiddle', hour: '2 300 ₽', month: '379 500 ₽' },
    { level: 'Middle', hour: '2 600 ₽', month: '429 000 ₽' },
    { level: 'Senior', hour: '2 700 ₽', month: '445 500 ₽' }
  ],
  10: [
    { level: 'Premiddle', hour: '2 800 ₽', month: '462 000 ₽' },
    { level: 'Middle', hour: '3 200 ₽', month: '528 000 ₽' },
    { level: 'Senior', hour: '3 700 ₽', month: '610 500 ₽' }
  ],
  11: [
    { level: 'Premiddle', hour: '1 900 ₽', month: '313 500 ₽' },
    { level: 'Middle', hour: '2 100 ₽', month: '346 500 ₽' },
    { level: 'Senior', hour: '2 500 ₽', month: '412 500 ₽' }
  ],
  12: [
    { level: 'Premiddle', hour: '2 800 ₽', month: '462 000 ₽' },
    { level: 'Middle', hour: '3 200 ₽', month: '528 000 ₽' },
    { level: 'Senior', hour: '3 700 ₽', month: '610 500 ₽' }
  ],
  13: [
    { level: 'Premiddle', hour: '2 600 ₽', month: '429 000 ₽' },
    { level: 'Middle', hour: '3 100 ₽', month: '511 500 ₽' },
    { level: 'Senior', hour: '3 400 ₽', month: '561 000 ₽' }
  ],
  14: [
    { level: 'Premiddle', hour: '1 900 ₽', month: '313 500 ₽' },
    { level: 'Middle', hour: '2 100 ₽', month: '346 500 ₽' },
    { level: 'Senior', hour: '2 300 ₽', month: '379 500 ₽' }
  ],
  15: [
    { level: 'Premiddle', hour: '2 000 ₽', month: '330 000 ₽' },
    { level: 'Middle', hour: '2 200 ₽', month: '363 000 ₽' },
    { level: 'Senior', hour: '2 400 ₽', month: '396 000 ₽' }
  ],
  16: [
    { level: 'Premiddle', hour: '2 100 ₽', month: '346 500 ₽' },
    { level: 'Middle', hour: '2 400 ₽', month: '396 000 ₽' },
    { level: 'Senior', hour: '2 600 ₽', month: '429 000 ₽' }
  ],
  17: [
    { level: 'Premiddle', hour: '1 600 ₽', month: '264 000 ₽' },
    { level: 'Middle', hour: '1 900 ₽', month: '313 500 ₽' },
    { level: 'Senior', hour: '2 100 ₽', month: '346 500 ₽' }
  ],
  18: [
    { level: 'Premiddle', hour: '1 900 ₽', month: '313 500 ₽' },
    { level: 'Middle', hour: '2 100 ₽', month: '346 500 ₽' },
    { level: 'Senior', hour: '2 300 ₽', month: '379 500 ₽' }
  ],
}

const currentPrices = computed(() => prices[currentIndex.value])

const next = () => {
  currentIndex.value = (currentIndex.value + 1) % roles.length
}

const prev = () => {
  currentIndex.value =
    (currentIndex.value - 1 + roles.length) % roles.length
}
</script>

<template>
  <div class="salary">

    <div class="carousel">
      <button @click="prev">
        <img src="@/assets/img/start/left.svg" alt="">
      </button>
      <div class="role">{{ roles[currentIndex] }}</div>
      <button @click="next">
        <img src="@/assets/img/start/right.svg" alt="">
      </button>
    </div>

    <div class="grid">
      <div class="labels">
        <div>УРОВЕНЬ</div>
        <div>ЧАС</div>
        <div>МЕСЯЦ</div>
      </div>

      <div class="cards">
        <div 
          v-for="item in currentPrices" 
          :key="item.level"
          class="card"
        >
          <div>{{ item.level }}</div>
          <div>{{ item.hour }}</div>
          <div>{{ item.month }}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
.salary{
  color: white;
  font-family: Arial, sans-serif;
  text-align: center;
  margin-bottom: 200px;
}

.carousel{
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  gap: 9px;
  margin: 120px 0;
}

.role{
  display: flex;
  min-width: 600px;
  height: 60px;
  border: 1px solid white;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  padding: 0 5px;
}

button{
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 20px;
}

.grid{
  display: flex;
  justify-content: center;
  gap: 20px;
}

.labels{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: left;
  gap: 40px;
  font-size: 32px;
  padding: 55px 75px;
}

.cards{
  display: flex;
  gap: 40px;
}

.card{
  border: 1px solid rgba(255,255,255,1);
  padding: 55px 75px;
  font-size: 32px;
  display: flex;
  flex-direction: column;
  gap: 80px;
}

@media screen and (max-width: 1600px) {
  .card, .labels, .role {
    font-size: 24px;
  }
}

@media screen and (max-width: 1300px) {
  .labels {
    display: none;
  }
  .cards {
    flex-direction: column;
  }
}

@media screen and (max-width: 760px) {
  .labels {
    display: none;
  }
  .cards {
    flex-direction: column;
  }
  .role {
    min-width: 250px;
    width: 250px;
  }
}
</style>